import React from 'react';
import Search from './components/Search';
import './App.css';

const App = () => <Search />;

export default App;
